module.exports = __webpack_public_path__ + "static/media/eye-text.4f6e1856.svg";